module.exports = __webpack_public_path__ + "assets/img/nowFinish.bcf54c2d.png";